import { authApi } from '.';

// Bu dosya API generator tarafından üretilmez — güvenle düzenlenebilir.
export const authApiWithTags = authApi.enhanceEndpoints({
  endpoints: {
    // ---- Address Data (static lookup) ----
    getCities: { providesTags: ['AddressData'] },
    getDistricts: { providesTags: ['AddressData'] },
    getNeighborhoods: { providesTags: ['AddressData'] },
    getStreets: { providesTags: ['AddressData'] },

    // ---- Addresses ----
    getAddresses: { providesTags: ['Addresses'] },
    getAddress: { providesTags: ['Addresses'] },
    getAddressesByUserId: { providesTags: ['Addresses'] },
    createAddress: { invalidatesTags: ['Addresses'] },
    updateAddress: { invalidatesTags: ['Addresses'] },
    deleteAddress: { invalidatesTags: ['Addresses'] },

    // ---- App Version ----
    checkAppVersionAsync: { providesTags: ['AppVersion'] },

    // ---- Auth / Session ----
    getLoginHistory: { providesTags: ['LoginHistory'] },
    getLastLoginAlert: { providesTags: ['LoginHistory'] },
    loginUser: { invalidatesTags: ['User', 'LoginHistory'] },
    logoutUser: {
      invalidatesTags: [
        'User',
        'LoginHistory',
        'Contract',
        'Addresses',
        'Devices',
        'NotificationPermissions',
        'CommunicationPermissions',
      ],
    },
    refreshAccessToken: { invalidatesTags: ['User'] },

    // ---- User ----
    getCurrentUser: { providesTags: ['User'] },
    getKycStatus: { providesTags: ['User'] },
    getUserProfileByPhone: { providesTags: ['User'] },
    updateAvatar: { invalidatesTags: ['User'] },
    updateEmail: { invalidatesTags: ['User'] },
    updatePhoneNumber: { invalidatesTags: ['User'] },
    updateMaritalStatus: { invalidatesTags: ['User'] },
    resetPassword: { invalidatesTags: ['User'] },
    confirmKyc: { invalidatesTags: ['User'] },
    deleteAccount: {
      invalidatesTags: [
        'User',
        'Addresses',
        'Contract',
        'Devices',
        'NotificationPermissions',
        'CommunicationPermissions',
      ],
    },

    // ---- Invited Users (Referrals) ----
    getInvitedUsers: { providesTags: ['InvitedUsers'] },
    getInvitedUsersCount: { providesTags: ['InvitedUsers'] },
    // Summary endpoint feeds the MainInviteCard avatar stack on home /
    // profile-home; sharing the same tag means an `inviteUsersByPhone`
    // mutation refreshes both the history list and the summary card with a
    // single round-trip.
    getInvitedUsersSummary: { providesTags: ['InvitedUsers'] },
    inviteUsersByPhone: { invalidatesTags: ['InvitedUsers'] },

    // ---- Devices ----
    getDevicesByUserId: { providesTags: ['Devices'] },
    getDevice: { providesTags: ['Devices'] },
    createDevice: { invalidatesTags: ['Devices'] },
    deleteDevice: { invalidatesTags: ['Devices'] },

    // ---- Notification Permissions ----
    getNotificationPermissions: { providesTags: ['NotificationPermissions'] },
    getNotificationPermissionsJson: {
      providesTags: ['NotificationPermissions'],
    },
    createNotificationPermission: {
      invalidatesTags: ['NotificationPermissions'],
    },
    updateNotificationPermission: {
      invalidatesTags: ['NotificationPermissions'],
    },
    syncNotificationPermissions: {
      invalidatesTags: ['NotificationPermissions'],
    },

    // ---- Communication Permissions ----
    getCommunicationPermissions: {
      providesTags: ['CommunicationPermissions'],
    },
    getCommunicationPermissionsJson: {
      providesTags: ['CommunicationPermissions'],
    },
    createCommunicationPermission: {
      invalidatesTags: ['CommunicationPermissions'],
    },
    updateCommunicationPermission: {
      invalidatesTags: ['CommunicationPermissions'],
    },
    syncCommunicationPermissions: {
      invalidatesTags: ['CommunicationPermissions'],
    },

    // ---- Support Requests ----
    getSupportRequestsEndpoint: { providesTags: ['SupportRequests'] },
    getSupportRequestDetailEndpoint: { providesTags: ['SupportRequests'] },
    createSupportRequestEndpoint: { invalidatesTags: ['SupportRequests'] },
    addSupportRequestCommentEndpoint: {
      invalidatesTags: ['SupportRequests'],
    },

    // ---- Service Status ----
    getServiceStatus: { providesTags: ['ServiceStatus'] },
    getServiceStatusByName: { providesTags: ['ServiceStatus'] },
  },
});
